import { firebaseService } from '../../firebaseApp'
import { queryClient } from '../queryClient'
import { Profile } from './views'

export const QueryKeys = {
  me: queryClient.dynamicQueryKey<Profile>(() => ['me', firebaseService?.instance?.auth()?.currentUser?.uid]),
  options: queryClient.queryKey(['options']),
  create: queryClient.queryKey(['createProfile']),
  update: queryClient.queryKey(['updateProfile'])
}
